import { MolsonBox, MolsonIcon, MolsonTypography } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'

type PriceDifferenceDisplayProps = {
  oldPrice: number
  newPrice: number
  formatPriceAndCurrency: (price: number) => string
}

export const PriceDifferenceDisplay = ({
  oldPrice,
  newPrice,
  formatPriceAndCurrency
}: PriceDifferenceDisplayProps) => {
  const theme = molsonUseTheme()
  return (
    <MolsonBox
      sx={{ alignItems: 'center', display: 'flex', gap: 0.5, width: '100%' }}
    >
      <MolsonTypography
        sx={{
          color: theme.palette.secondary[500],
          pl: 2,
          textDecoration: 'line-through'
        }}
      >
        {formatPriceAndCurrency(oldPrice)}
      </MolsonTypography>
      <MolsonIcon
        variant={newPrice > oldPrice ? 'ARROW_UPWARD' : 'ARROW_DOWNWARD'}
        iconColor={newPrice > oldPrice ? 'success' : 'error'}
      />
      <MolsonTypography color={theme.palette.secondary[600]} variant="h4">
        {formatPriceAndCurrency(newPrice)}
      </MolsonTypography>
    </MolsonBox>
  )
}
